import React from 'react'

export const extractReactNodeText = (node) => {
  if (node === null || node === undefined) return ''

  if (typeof node === 'string' || typeof node === 'number') {
    return `${node}`
  }

  if (Array.isArray(node)) {
    return node
      .map((child) => extractReactNodeText(child))
      .filter(Boolean)
      .join(' ')
      .trim()
  }

  if (React.isValidElement(node)) {
    const { props } = node

    return (
      extractReactNodeText(props?.title) ||
      extractReactNodeText(props?.children) ||
      extractReactNodeText(props?.label) ||
      extractReactNodeText(props?.option?.label) ||
      extractReactNodeText(props?.option?.title) ||
      ''
    )
  }

  if (typeof node === 'object') {
    return (
      extractReactNodeText(node.label) ||
      extractReactNodeText(node.value) ||
      extractReactNodeText(node.title) ||
      extractReactNodeText(node.children) ||
      extractReactNodeText(node.option?.label) ||
      extractReactNodeText(node.option?.title) ||
      ''
    )
  }

  return ''
}

export const getPlaceholderTooltipItems = (items) => {
  if (!Array.isArray(items)) return []

  return items
    .map((item) => {
      const extractLabel = () => {
        if (item?.data) {
          const fromData = extractReactNodeText(item.data.label || item.data.title)
          if (fromData) {
            return fromData
          }
        }

        const fromLabel = extractReactNodeText(item?.label)
        if (fromLabel) {
          return fromLabel
        }

        return extractReactNodeText(item)
      }

      const label = extractLabel()
      if (!label) return null

      const resolveKey = () => {
        if (item?.data) {
          const dataKey =
            item.data.value ??
            item.data.key ??
            extractReactNodeText(item.data.label || item.data.title)

          if (dataKey) {
            return `${dataKey}`
          }
        }

        if (item && typeof item === 'object' && !React.isValidElement(item)) {
          const optionKey = item.value ?? item.key
          if (optionKey !== undefined) {
            return `${optionKey}`
          }
        }

        if (React.isValidElement(item)) {
          const elementKey = item.props?.value ?? item.props?.id ?? item.key
          if (elementKey !== undefined) {
            return `${elementKey}`
          }
        }

        return `${label}`
      }

      return {
        key: resolveKey(),
        label,
      }
    })
    .filter(Boolean)
}
